export default {
    // Header Section
    "discover_your": "ನಿಮ್ಮ",
    "life_predictions": "ಜೀವನ ಭವಿಷ್ಯವಾಣಿಗಳನ್ನು ಅನ್ವೇಷಿಸಿ",
    "future_unveiled_through_stars": "ನಕ್ಷತ್ರಗಳ ಮೂಲಕ ಬಹಿರಂಗವಾದ ಭವಿಷ್ಯ",
    "life_predictions_description": "ವೈದಿಕ ಜ್ಯೋತಿಷ್ಯ ಮತ್ತು ಗ್ರಹ ವಿಶ್ಲೇಷಣೆಯ ಆಧಾರದ ಮೇಲೆ ಸಮಗ್ರ ಜೀವನ ಭವಿಷ್ಯವಾಣಿಗಳನ್ನು ಪಡೆಯಿರಿ. ನಿಖರವಾದ ಜ್ಯೋತಿಷ್ಯ ಒಳನೋಟಗಳೊಂದಿಗೆ ನಿಮ್ಮ ಭವಿಷ್ಯದ ಮೈಲಿಗಲ್ಲುಗಳು, ಪ್ರಮುಖ ಜೀವನ ಘಟನೆಗಳು, ವೃತ್ತಿ ಬೆಳವಣಿಗೆ, ವಿವಾಹದ ಸಮಯ, ಸಂಪತ್ತು ಸಂಗ್ರಹ ಮತ್ತು ಆಧ್ಯಾತ್ಮಿಕ ಪ್ರಯಾಣವನ್ನು ತಿಳಿದುಕೊಳ್ಳಿ.",

    // Service Information
    "enter_details_for_predictions": "ಜೀವನ ಭವಿಷ್ಯವಾಣಿಗಳಿಗಾಗಿ ನಿಮ್ಮ ವಿವರಗಳನ್ನು ನಮೂದಿಸಿ",
    "complete_life_predictions": "ಸಂಪೂರ್ಣ ಜೀವನ ಭವಿಷ್ಯವಾಣಿಗಳು",
    "service_price": "ಸೇವೆಯ ಬೆಲೆ",
    "comprehensive_life_predictions_note": "ನಿಮ್ಮ ಭವಿಷ್ಯದ ಜೀವನ ಘಟನೆಗಳು ಮತ್ತು ಜ್ಯೋತಿಷ್ಯ ಮಾರ್ಗದರ್ಶನದ ವಿಸ್ತೃತ ವಿಶ್ಲೇಷಣೆ",

    // Form Fields
    "full_name": "ಪೂರ್ಣ ಹೆಸರು",
    "enter_full_name": "ನಿಮ್ಮ ಪೂರ್ಣ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
    "name_destiny_influence": "ನಿಮ್ಮ ಹೆಸರಿನ ಕಂಪನಗಳು ನಿಮ್ಮ ಭಾಗ್ಯ ಮತ್ತು ಭವಿಷ್ಯದ ಅವಕಾಶಗಳನ್ನು ರೂಪಿಸುತ್ತವೆ",
    "email_address": "ಇಮೇಲ್ ವಿಳಾಸ",
    "enter_email_address": "ನಿಮ್ಮ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ",
    "phone_number": "ದೂರವಾಣಿ ಸಂಖ್ಯೆ",
    "enter_phone_number": "ನಿಮ್ಮ ದೂರವಾಣಿ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
    "gender": "ಲಿಂಗ",
    "male": "ಪುರುಷ",
    "female": "ಮಹಿಳೆ",
    "other": "ಇತರೆ",
    "date_of_birth": "ಜನ್ಮ ದಿನಾಂಕ",
    "birth_date_future_insights": "ಗ್ರಹ ಅವಧಿಗಳು ಮತ್ತು ಭವಿಷ್ಯದ ಭವಿಷ್ಯವಾಣಿಗಳನ್ನು ಲೆಕ್ಕಾಚಾರ ಮಾಡಲು ಅತ್ಯಗತ್ಯ",
    "time_of_birth": "ಜನ್ಮ ಸಮಯ",
    "exact_time_critical_for_predictions": "ನಿಖರವಾದ ದಶಾ ಲೆಕ್ಕಾಚಾರಗಳು ಮತ್ತು ಭವಿಷ್ಯವಾಣಿಗಳಿಗೆ ನಿಖರವಾದ ಸಮಯ ಅಗತ್ಯ",
    "place_of_birth": "ಜನ್ಮ ಸ್ಥಳ",
    "place_of_birth_placeholder": "ನಗರ, ರಾಜ್ಯ, ದೇಶ",
    "location_essential_for_predictions": "ಸ್ಥಳವು ಭವಿಷ್ಯದ ಘಟನೆಗಳನ್ನು ಪ್ರಭಾವಿಸುವ ಗ್ರಹ ಸ್ಥಾನಗಳನ್ನು ಪರಿಣಾಮ ಬೀರುತ್ತದೆ",
    "preferred_language": "ಆದ್ಯತೆಯ ಭಾಷೆ",
    "english": "ಇಂಗ್ಲಿಷ್",
    "hindi": "ಹಿಂದಿ",
    "telugu": "ತೆಲುಗು",
    "kannada": "ಕನ್ನಡ",
    "language_note": "ಆಯ್ಕೆಮಾಡಿದ ಭಾಷೆಯಲ್ಲಿ ನಿಮ್ಮ ಜೀವನ ಭವಿಷ್ಯವಾಣಿಗಳನ್ನು ವಿತರಿಸಲಾಗುವುದು",

    // Core Prediction Features
    "future_life_events_predictions": "ಭವಿಷ್ಯದ ಜೀವನ ಘಟನೆಗಳ ಭವಿಷ್ಯವಾಣಿಗಳು",
    "career_success_timeline": "ವೃತ್ತಿ ಯಶಸ್ಸಿನ ಸಮಯಸೂಚಿ",
    "marriage_relationship_predictions": "ವಿವಾಹ ಮತ್ತು ಸಂಬಂಧದ ಭವಿಷ್ಯವಾಣಿಗಳು",
    "wealth_prosperity_forecast": "ಸಂಪತ್ತು ಮತ್ತು ಸಮೃದ್ಧಿ ಮುನ್ಸೂಚನೆ",
    "health_longevity_insights": "ಆರೋಗ್ಯ ಮತ್ತು ದೀರ್ಘಾಯುಷ್ಯ ಒಳನೋಟಗಳು",
    "pdf_download": "ಸಮಗ್ರ PDF ವರದಿ",

    "what_you_get": "ನಿಮ್ಮ ಜೀವನ ಭವಿಷ್ಯವಾಣಿಗಳಲ್ಲಿ ಏನು ಸೇರಿದೆ",
    "comprehensive_future_roadmap": "ಸಮಗ್ರ ಭವಿಷ್ಯದ ರೋಡ್‌ಮ್ಯಾಪ್",
    "major_life_events_timeline": "ಪ್ರಮುಖ ಜೀವನ ಘಟನೆಗಳ ಸಮಯಸೂಚಿ",
    "planetary_influence_analysis": "ಗ್ರಹ ಪ್ರಭಾವ ವಿಶ್ಲೇಷಣೆ",
    "remedial_guidance_solutions": "ಪರಿಹಾರಾತ್ಮಕ ಮಾರ್ಗದರ್ಶನ ಮತ್ತು ಪರಿಹಾರಗಳು",

    // Actions & Buttons
    "pay_and_generate_analysis": "ನನ್ನ ಜೀವನ ಭವಿಷ್ಯವಾಣಿಗಳನ್ನು ಪಡೆಯಿರಿ",
    "processing_payment": "ಪಾವತಿ ಸಂಸ್ಕರಿಸುತ್ತಿದೆ",
    "processing_request": "ಭವಿಷ್ಯವಾಣಿಗಳನ್ನು ರಚಿಸುತ್ತಿದೆ",

    // Payment & Success Messages
    "thank_you": "ಧನ್ಯವಾದಗಳು",
    "payment_successful": "ಪಾವತಿ ಯಶಸ್ವಿಯಾಗಿದೆ!",
    "life_predictions_processing": "ನಿಮ್ಮ ಜೀವನ ಭವಿಷ್ಯವಾಣಿಗಳನ್ನು ನಮ್ಮ ಪರಿಣಿತ ವೈದಿಕ ಜ್ಯೋತಿಷಿಗಳು ತಯಾರಿಸುತ್ತಿದ್ದಾರೆ. ನಿಮ್ಮ ಭವಿಷ್ಯದ ಜೀವನ ಘಟನೆಗಳು ಮತ್ತು ಕಾಸ್ಮಿಕ್ ಸಮಯಸೂಚಿಯ ಬಗ್ಗೆ ವಿಸ್ತೃತ ಒಳನೋಟಗಳನ್ನು ನೀವು ಸ್ವೀಕರಿಸುತ್ತೀರಿ.",
    "order_id": "ಆರ್ಡರ್ ID",
    "payment_id": "ಪಾವತಿ ID",
    "amount_paid": "ಪಾವತಿಸಿದ ಮೊತ್ತ",

    // Delivery Information
    "delivery_information": "ವಿತರಣಾ ಮಾಹಿತಿ",
    "delivery_time": "ವಿಶ್ಲೇಷಣೆ ವಿತರಣೆ",
    "within_24_hours_delivery_note": "ನಿಮ್ಮ ವಿಸ್ತೃತ ಜೀವನ ಭವಿಷ್ಯವಾಣಿಗಳು ೨೪ ಗಂಟೆಗಳೊಳಗೆ ಸಿದ್ಧವಾಗುತ್ತವೆ",
    "whatsapp_notification": "WhatsApp ಅಪ್‌ಡೇಟ್‌ಗಳು",
    "whatsapp_delivery_note": "WhatsApp ನಲ್ಲಿ ತಕ್ಷಣ ಅಧಿಸೂಚನೆಗಳನ್ನು ಸ್ವೀಕರಿಸಿ",
    "email_delivery": "ಇಮೇಲ್ ವಿತರಣೆ",
    "email_delivery_note": "ಸಂಪೂರ್ಣ ಭವಿಷ್ಯವಾಣಿಗಳನ್ನು ವಿತರಿಸಲಾಗಿದೆ",

    // What You'll Receive
    "what_youll_receive": "ನಿಮ್ಮ ಜೀವನ ಭವಿಷ್ಯವಾಣಿ ಪ್ಯಾಕೇಜ್",
    "detailed_life_predictions": "ಸಮಗ್ರ ಜೀವನ ಭವಿಷ್ಯವಾಣಿ ವರದಿ (PDF)",
    "future_events_timeline": "ಭವಿಷ್ಯದ ಘಟನೆಗಳ ಸಮಯಸೂಚಿ ಮತ್ತು ದಿನಾಂಕಗಳು",
    "career_marriage_wealth_predictions": "ವೃತ್ತಿ, ವಿವಾಹ ಮತ್ತು ಸಂಪತ್ತು ಭವಿಷ್ಯವಾಣಿಗಳು",
    "planetary_periods_analysis": "ಗ್ರಹ ಅವಧಿಗಳ (ದಶಾ) ವಿಶ್ಲೇಷಣೆ",
    "remedial_solutions_guidance": "ಪರಿಹಾರಾತ್ಮಕ ಪರಿಹಾರಗಳು ಮತ್ತು ಮಾರ್ಗದರ್ಶನ",

    // Visual Content
    "sample_life_predictions": "ಮಾದರಿ ಜೀವನ ಭವಿಷ್ಯವಾಣಿಗಳು",
    "major_life_milestone": "ಪ್ರಮುಖ ಜೀವನ ಮೈಲಿಗಲ್ಲು",
    "sample_prediction_reading": "ಮುಂದಿನ ೨-೩ ವರ್ಷಗಳಲ್ಲಿ ವೃತ್ತಿ ಪ್ರಗತಿ ಮತ್ತು ವಿವಾಹದ ನಿರೀಕ್ಷೆಗಳು",
    "sample_predictions_preview": "ಸಮಯಸೂಚಿ ಒಳನೋಟಗಳೊಂದಿಗೆ ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಜೀವನ ಭವಿಷ್ಯವಾಣಿಗಳ ಪೂರ್ವವೀಕ್ಷಣೆ",
    "life_prediction_areas": "ಜೀವನ ಭವಿಷ್ಯವಾಣಿ ಕ್ಷೇತ್ರಗಳು",

    // Life Area Types
    "career": "ವೃತ್ತಿ",
    "marriage": "ವಿವಾಹ",
    "wealth": "ಸಂಪತ್ತು",
    "family": "ಕುಟುಂಬ",
    "health": "ಆರೋಗ್ಯ",
    "education": "ಶಿಕ್ಷಣ",

    // Status & Processing
    "your_predictions_status": "ನಿಮ್ಮ ಜೀವನ ಭವಿಷ್ಯವಾಣಿಗಳ ಸ್ಥಿತಿ",
    "processing_your_predictions": "ನಿಮ್ಮ ಭವಿಷ್ಯವನ್ನು ವಿಶ್ಲೇಷಿಸುತ್ತಿದೆ",
    "predictions_processing_message": "ನಮ್ಮ ವೈದಿಕ ಜ್ಯೋತಿಷ್ಯ ಪರಿಣಿತರು ನಿಮ್ಮ ಜನ್ಮ ಕುಂಡಲಿಯ ಆಧಾರದ ಮೇಲೆ ನಿಮ್ಮ ಗ್ರಹ ಅವಧಿಗಳನ್ನು ಲೆಕ್ಕಾಚಾರ ಮಾಡುತ್ತಿದ್ದಾರೆ ಮತ್ತು ಭವಿಷ್ಯದ ಘಟನೆಗಳನ್ನು ವಿಶ್ಲೇಷಿಸುತ್ತಿದ್ದಾರೆ.",
    "request_id": "ವಿಶ್ಲೇಷಣೆ ID",
    "status": "ಸ್ಥಿತಿ",
    "processing": "ಪ್ರಗತಿಯಲ್ಲಿದೆ",
    "pending": "ಸರದಿಯಲ್ಲಿದೆ",
    "email_notification_sent": "ದೃಢೀಕರಣ ಇಮೇಲ್ ಕಳುಹಿಸಲಾಗಿದೆ",
    "whatsapp_update_coming": "WhatsApp ಅಪ್‌ಡೇಟ್‌ಗಳು ಸಕ್ರಿಯಗೊಳಿಸಲಾಗಿದೆ",
    "delivery_within_24_hours": "ವರದಿ ೨೪ ಗಂಟೆಗಳೊಳಗೆ ಸಿದ್ಧ",

    // Support & Contact
    "contact_support": "ಜ್ಯೋತಿಷ್ಯ ಬೆಂಬಲವನ್ನು ಸಂಪರ್ಕಿಸಿ",
    "need_help": "ಮಾರ್ಗದರ್ಶನ ಬೇಕೇ?",
    "contact_us_at": "ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ",

    // Error Messages
    "please_fill_all_required_fields": "ದಯವಿಟ್ಟು ಎಲ್ಲಾ ಅಗತ್ಯ ಜನ್ಮ ವಿವರಗಳನ್ನು ಪೂರ್ಣಗೊಳಿಸಿ",
    "payment_failed": "ಪಾವತಿ ಯಶಸ್ವಿಯಾಗಲಿಲ್ಲ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    "processing_failed": "ಭವಿಷ್ಯವಾಣಿಗಳ ಸಂಸ್ಕರಣೆ ವಿಫಲವಾಗಿದೆ. ನಮ್ಮ ಬೆಂಬಲ ತಂಡವನ್ನು ಸಂಪರ್ಕಿಸಿ.",

    // Prediction-Specific Elements
    "planetary_periods": "ಗ್ರಹ ಅವಧಿಗಳು (ದಶೆಗಳು)",
    "mahadasha": "ಮಹಾದಶೆ ಅವಧಿಗಳು",
    "antardasha": "ಅಂತರ್ದಶೆ ಉಪ-ಅವಧಿಗಳು",
    "pratyantar_dasha": "ಪ್ರತ್ಯಂತರ್ ದಶೆ",
    "transit_analysis": "ಗ್ರಹ ಸಂಚಾರಗಳು",
    "yogas_combinations": "ಶುಭ ಯೋಗಗಳು ಮತ್ತು ಸಂಯೋಜನೆಗಳು",

    // Life Events Predictions
    "career_milestones": "ವೃತ್ತಿ ಮೈಲಿಗಲ್ಲುಗಳು",
    "job_changes": "ಉದ್ಯೋಗ ಬದಲಾವಣೆಗಳು ಮತ್ತು ಪ್ರೋನ್ನತಿಗಳು",
    "business_opportunities": "ವ್ಯಾಪಾರ ಅವಕಾಶಗಳು",
    "educational_achievements": "ಶೈಕ್ಷಣಿಕ ಸಾಧನೆಗಳು",
    "marriage_timing": "ವಿವಾಹದ ಸಮಯ",
    "childbirth_predictions": "ಮಕ್ಕಳ ಜನ್ಮ ಭವಿಷ್ಯವಾಣಿಗಳು",
    "property_acquisition": "ಆಸ್ತಿ ಮತ್ತು ರಿಯಲ್ ಎಸ್ಟೇಟ್",
    "travel_opportunities": "ಪ್ರವಾಸ ಮತ್ತು ವಿದೇಶಿ ಅವಕಾಶಗಳು",

    // Career Predictions
    "professional_growth": "ವೃತ್ತಿಪರ ಬೆಳವಣಿಗೆಯ ಸಮಯಸೂಚಿ",
    "success_periods": "ಯಶಸ್ಸು ಮತ್ತು ಮಾನ್ಯತೆ ಅವಧಿಗಳು",
    "career_challenges": "ವೃತ್ತಿ ಸವಾಲಿನ ಅವಧಿಗಳು",
    "leadership_roles": "ನಾಯಕತ್ವ ಅವಕಾಶಗಳು",
    "business_ventures": "ವ್ಯಾಪಾರ ಉದ್ಯಮಗಳ ಯಶಸ್ಸು",
    "financial_growth": "ಹಣಕಾಸಿನ ಬೆಳವಣಿಗೆಯ ಮಾದರಿಗಳು",

    // Marriage & Relationships
    "love_life_predictions": "ಪ್ರೇಮ ಜೀವನ ಭವಿಷ್ಯವಾಣಿಗಳು",
    "marriage_compatibility": "ವಿವಾಹ ಪಾಲುದಾರರ ಹೊಂದಾಣಿಕೆ",
    "relationship_timing": "ಸಂಬಂಧದ ಮೈಲಿಗಲ್ಲುಗಳು",
    "family_expansion": "ಕುಟುಂಬ ಬೆಳವಣಿಗೆ ಮತ್ತು ಮಕ್ಕಳು",
    "marital_harmony": "ವೈವಾಹಿಕ ಸಾಮರಸ್ಯ ಅವಧಿಗಳು",
    "relationship_challenges": "ಸಂಬಂಧ ಸವಾಲಿನ ಅವಧಿಗಳು",

    // Wealth & Finance
    "wealth_accumulation": "ಸಂಪತ್ತು ಸಂಗ್ರಹ ಸಮಯಸೂಚಿ",
    "investment_success": "ಹೂಡಿಕೆ ಯಶಸ್ಸಿನ ಅವಧಿಗಳು",
    "property_gains": "ಆಸ್ತಿ ಮತ್ತು ಸಂಪತ್ತು ಲಾಭಗಳು",
    "business_profits": "ವ್ಯಾಪಾರ ಲಾಭದ ಚಕ್ರಗಳು",
    "financial_setbacks": "ಹಣಕಾಸಿನ ಸವಾಲಿನ ಅವಧಿಗಳು",
    "debt_recovery": "ಸಾಲ ಮರುಪಾವತಿ ಮತ್ತು ಹಣಕಾಸಿನ ಸ್ಥಿರತೆ",

    // Health & Longevity
    "health_timeline": "ಆರೋಗ್ಯ ಸಮಯಸೂಚಿ ಭವಿಷ್ಯವಾಣಿಗಳು",
    "disease_periods": "ಆರೋಗ್ಯ ಸವಾಲಿನ ಅವಧಿಗಳು",
    "recovery_periods": "ಚೇತರಿಕೆ ಮತ್ತು ಚಿಕಿತ್ಸೆಯ ಅವಧಿಗಳು",
    "longevity_analysis": "ದೀರ್ಘಾಯುಷ್ಯ ಮತ್ತು ಜೀವಿತಾವಧಿ ವಿಶ್ಲೇಷಣೆ",
    "accident_prone_periods": "ಅಪಘಾತ ಒಳಗಾಗುವ ಅವಧಿಗಳು",
    "vitality_enhancement": "ಜೀವಶಕ್ತಿ ವರ್ಧನೆ ಅವಧಿಗಳು",

    // Family & Social
    "family_events": "ಕುಟುಂಬ ಘಟನೆಗಳು ಮತ್ತು ಮೈಲಿಗಲ್ಲುಗಳು",
    "children_predictions": "ಮಕ್ಕಳ-ಸಂಬಂಧಿತ ಭವಿಷ್ಯವಾಣಿಗಳು",
    "parental_health": "ಪೋಷಕರ ಆರೋಗ್ಯ ಮತ್ತು ಯೋಗಕ್ಷೇಮ",
    "sibling_relationships": "ಸಹೋದರ ಸಹೋದರಿಯರ ಸಂಬಂಧಗಳು",
    "social_recognition": "ಸಾಮಾಜಿಕ ಸ್ಥಾನಮಾನ ಮತ್ತು ಮಾನ್ಯತೆ",
    "community_involvement": "ಸಮುದಾಯ ನಾಯಕತ್ವ ಪಾತ್ರಗಳು",

    // Spiritual & Personal Growth
    "spiritual_awakening": "ಆಧ್ಯಾತ್ಮಿಕ ಜಾಗೃತಿ ಅವಧಿಗಳು",
    "religious_inclinations": "ಧಾರ್ಮಿಕ ಮತ್ತು ಆಧ್ಯಾತ್ಮಿಕ ಪ್ರವೃತ್ತಿಗಳು",
    "pilgrimage_opportunities": "ತೀರ್ಥಯಾತ್ರೆ ಮತ್ತು ಪವಿತ್ರ ಪ್ರಯಾಣಗಳು",
    "meditation_periods": "ಧ್ಯಾನ ಮತ್ತು ಆಂತರಿಕ ಬೆಳವಣಿಗೆ",
    "guru_connections": "ಆಧ್ಯಾತ್ಮಿಕ ಶಿಕ್ಷಕರ ಸಂಪರ್ಕಗಳು",
    "moksha_path": "ಮುಕ್ತಿ ಮತ್ತು ಜ್ಞಾನೋದಯ ಮಾರ್ಗ",

    // Timing & Cycles
    "auspicious_periods": "ಶುಭ ಸಮಯ ಅವಧಿಗಳು",
    "challenging_periods": "ಸವಾಲಿನ ಸಮಯ ಅವಧಿಗಳು",
    "neutral_periods": "ತಟಸ್ಥ ಮತ್ತು ಸ್ಥಿರ ಅವಧಿಗಳು",
    "transformation_phases": "ಪ್ರಮುಖ ರೂಪಾಂತರ ಹಂತಗಳು",
    "opportunity_windows": "ಅವಕಾಶದ ಕಿಟಕಿಗಳು",
    "decision_making_periods": "ಅತ್ಯುತ್ತಮ ನಿರ್ಧಾರ ತೆಗೆದುಕೊಳ್ಳುವ ಸಮಯಗಳು",

    // Age-Based Predictions
    "childhood_predictions": "ಬಾಲ್ಯ ಮತ್ತು ಆರಂಭಿಕ ಜೀವನ",
    "teenage_predictions": "ಹದಿಹರೆಯ ಮತ್ತು ಯುವಕರ ಭವಿಷ್ಯವಾಣಿಗಳು",
    "young_adult_phase": "ಯುವ ವಯಸ್ಕ ಹಂತ (೨೦-೩೫)",
    "middle_age_predictions": "ಮಧ್ಯವಯಸ್ಸಿನ ಭವಿಷ್ಯವಾಣಿಗಳು (೩೫-೫೫)",
    "senior_years": "ಹಿರಿಯ ವರ್ಷಗಳು ಮತ್ತು ನಿವೃತ್ತಿ",
    "life_completion": "ಜೀವನ ಪೂರ್ಣತೆ ಮತ್ತು ಪರಂಪರೆ",

    // Remedies & Solutions
    "planetary_remedies": "ಗ್ರಹ ಪರಿಹಾರಗಳು",
    "gemstone_recommendations": "ರತ್ನ ಶಿಫಾರಸುಗಳು",
    "mantra_chanting": "ಪ್ರಯೋಜನಕಾರಿ ಮಂತ್ರಗಳು",
    "charity_suggestions": "ದಾನಧರ್ಮ ಚಟುವಟಿಕೆಗಳು",
    "ritual_recommendations": "ವಿಧಿ ಮತ್ತು ಪೂಜೆಯ ಶಿಫಾರಸುಗಳು",
    "lifestyle_modifications": "ಜೀವನಶೈಲಿ ಮಾರ್ಪಾಡುಗಳು",

    // Advanced Predictions
    "karma_analysis": "ಕರ್ಮ ಮಾದರಿ ವಿಶ್ಲೇಷಣೆ",
    "past_life_influences": "ಹಿಂದಿನ ಜನ್ಮದ ಪ್ರಭಾವಗಳು",
    "soul_purpose": "ಆತ್ಮದ ಉದ್ದೇಶ ಮತ್ತು ಧ್ಯೇಯ",
    "destiny_fulfillment": "ಭಾಗ್ಯ ಪೂರೈಕೆ ಮಾರ್ಗ",
    "life_lessons": "ಪ್ರಮುಖ ಜೀವನ ಪಾಠಗಳು",
    "evolutionary_growth": "ವಿಕಸನೀಯ ಆತ್ಮ ಬೆಳವಣಿಗೆ",

    // Specific Event Timing
    "marriage_age_prediction": "ವಿವಾಹ ವಯಸ್ಸಿನ ಭವಿಷ್ಯವಾಣಿ",
    "first_child_timing": "ಮೊದಲ ಮಗುವಿನ ಸಮಯ",
    "career_peak_period": "ವೃತ್ತಿ ಶಿಖರ ಅವಧಿ",
    "maximum_wealth_phase": "ಗರಿಷ್ಠ ಸಂಪತ್ತಿನ ಹಂತ",
    "health_recovery_timing": "ಆರೋಗ್ಯ ಚೇತರಿಕೆ ಸಮಯ",
    "spiritual_realization": "ಆಧ್ಯಾತ್ಮಿಕ ಸಾಕ್ಷಾತ್ಕಾರ ಹಂತ",

    // Global & Environmental
    "foreign_opportunities": "ವಿದೇಶಿ ಪ್ರವಾಸ ಮತ್ತು ಅವಕಾಶಗಳು",
    "relocation_predictions": "ಸ್ಥಳಾಂತರ ಮತ್ತು ವಲಸೆ",
    "global_connections": "ಅಂತರರಾಷ್ಟ್ರೀಯ ಸಂಪರ್ಕಗಳು",
    "cultural_exchanges": "ಸಾಂಸ್ಕೃತಿಕ ಮತ್ತು ಶೈಕ್ಷಣಿಕ ವಿನಿಮಯಗಳು",
    "technology_adaptations": "ತಂತ್ರಜ್ಞಾನ ಮತ್ತು ನಾವೀನ್ಯತೆ ಒಳಗೊಳ್ಳುವಿಕೆ",

    // Detailed Time Frames
    "next_year_predictions": "ಮುಂದಿನ ವರ್ಷದ ಭವಿಷ್ಯವಾಣಿಗಳು",
    "next_5_years": "ಮುಂದಿನ ೫ ವರ್ಷಗಳ ವಿಮರ್ಶೆ",
    "next_10_years": "ಮುಂದಿನ ದಶಕದ ಮುನ್ಸೂಚನೆ",
    "life_phases": "ಪ್ರಮುಖ ಜೀವನ ಹಂತಗಳು",
    "cyclical_patterns": "ಪುನರಾವರ್ತಿತ ಜೀವನ ಮಾದರಿಗಳು",
    "milestone_achievements": "ಪ್ರಮುಖ ಮೈಲಿಗಲ್ಲು ಸಾಧನೆಗಳು"
};
